import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './NavBar.css';
import {
	useDispatch
} from 'react-redux';
import {
	setCurrentPage,
	signOut
} from '../../store/pageLayoutSlice';
import {
	clearStateValues
} from '../../store/quotesAndNotificationsSlice';
import {
    Icons
} from './Icons';

function NavBar(props){

	const dispatch =  useDispatch();
	const [ isOpen, setIsOpen ] = useState(false);
	const [ hasBeenToggled, setHasBeenToggled ] = useState(false);

	const {
		userPages,
		navState
	} = props;

	/**
	 * Reloading the page used to be a sign-out, back when being signed in was
	 * only a flag in Redux that a reload happened to clear. It is not one now:
	 * the session is a record on the server and the cookie survives a reload,
	 * so the app would come straight back up signed in. It has to be ended
	 * server-side, which is what the signOut thunk does.
	 *
	 * This lives inside the component because it needs dispatch - the previous
	 * version sat at module scope, where it could not have reached the store
	 * even if it had tried to.
	 */
	function handleSignOut(){
		dispatch( clearStateValues() );
		dispatch( signOut() );
	}

	function navigate(page){
		if( !navState[ page ] ){
			dispatch( setCurrentPage( page ) );
			dispatch( clearStateValues() );
		}
	}

	function listItemClass(isCurrentPage, isOpen){
		let className = "nav_list_item";
		if( isCurrentPage ){
			className += " nav_current";
		}
		if( isOpen ){
			className += " _open";
		}
		return className;
	}

	const navButtons = userPages.map((page, i) =>{
		const className=""
		return (
			<li
				key={page}
				className={ listItemClass(navState[ page ], isOpen) }
				title={ page }
				onClick={ () => navigate(page) }
			>
				<NavButton
					Id={ page.replace(' ', '_') }
					title={ page }
					icon={ Icons[ page ] }
				/>
				{
					isOpen &&
					<span className="page_name_span">{ page }</span>
				}
			</li>
		);
	});//'Sign Out'

	let arrowClass = "nav_bar_arrow_container";

	if( isOpen ){
		arrowClass += " arrow_left";
	} else if( hasBeenToggled ){
		arrowClass += " arrow_right";
	}

	return (
		<nav className="nav_bar">
			<div
				className={ arrowClass }
				onClick={ () => {
					setIsOpen(!isOpen);
					if( !hasBeenToggled ){
						setHasBeenToggled(true);
					}
				} }
			>
				<SideArrow />
			</div>
			<ul className="nav_list">
				{ navButtons }
			</ul>
			<ul id="sign_out_list" className="nav_list">
				<li
					className={ isOpen ? "nav_list_item _open" : "nav_list_item" }
					title='Sign Out'
					onClick={ handleSignOut }
				>
					<NavButton
						Id='Sign_Out'
						title='Sign Out'
						icon={ Icons[ 'Sign Out' ] }
					/>
					{
						isOpen &&
						<span className="page_name_span">Sign Out</span>
					}
				</li>
			</ul>
		</nav>
	);
}

function NavButton(props){
	return (
		<button
			id={ props.Id }
			onClick={ props.onClick }
			className="nav_button"
			title={ props.title }
		>
			{ props.icon }
		</button>
	);
}

function SideArrow(props){
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
          
            fill="#000"
            className="nav_bar_arrow"
            viewBox="0 0 15 15"
        >
            <path
                fillRule="evenodd"
                d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"
            />
        </svg>
    );
}

NavBar.propTypes = {
	userPages: PropTypes.array.isRequired,
	navState: PropTypes.object.isRequired
};

NavButton.propTypes = {
	Id: PropTypes.string.isRequired,
	title: PropTypes.string,
	icon: PropTypes.object.isRequired
};

export default NavBar;